import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cms-www",
  "use": "icon-cms-www-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-cms-www\"><path d=\"M110,193.8A83.8,83.8,0,1,1,193.8,110,83.89,83.89,0,0,1,110,193.8Zm0-158.6A74.8,74.8,0,1,0,184.8,110,74.89,74.89,0,0,0,110,35.2Z\" /><rect x=\"56.69\" y=\"86.38\" width=\"105.82\" height=\"9\" /><rect x=\"56.69\" y=\"123.55\" width=\"105.82\" height=\"9\" /><rect x=\"123.68\" y=\"56.55\" width=\"9\" height=\"105.82\" /><rect x=\"86.51\" y=\"56.55\" width=\"9\" height=\"105.82\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol